import {
  Box,
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { formatPrice } from 'BrokerTsLib/src/Utils/formatPrice'

const SliderThumbIcon = () => {
  return (
    <Box
      sx={{
        w: 'px',
        h: 2,
        position: 'relative',
        bg: 'gray.500',
        '&:before, &:after': {
          content: '""',
          position: 'absolute',
          w: 'px',
          h: 2,
          bg: 'gray.500',
        },
        '&:before': { left: '-3px' },
        '&:after': { left: '3px' },
      }}
    />
  )
}

export const LiabilitySlider = ({
  name,
  defaultValue,
  min,
  max,
  minLabel,
  maxLabel,
  step = 1,
  isDisabled,
  onChange,
}: {
  name: string
  defaultValue: number | undefined
  min: number
  max: number
  minLabel?: string | React.ReactNode
  maxLabel?: string | React.ReactNode
  step?: number
  isDisabled?: boolean
  onChange: (value: number) => void
}) => {
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <Slider
      aria-label={`slider-${name}`}
      value={value}
      maxW={'14rem'}
      min={min}
      max={max}
      step={step}
      focusThumbOnChange={false}
      sx={{ position: 'relative' }}
      onChange={(value) => {
        setValue(value)
        onChange(value)
      }}
      onChangeEnd={(value) => {
        onChange(value)
      }}
      isDisabled={isDisabled}
    >
      <SliderMark value={min} sx={{ position: 'absolute', left: 0, fontSize: 'sm' }}>
        {minLabel ?? `${formatPrice({ price: min, zeroLabel: '0 Kč' })}`}
      </SliderMark>

      <SliderMark
        value={max}
        sx={{
          position: 'absolute',
          left: '100%',
          transform: 'translateX(-100%)',
          fontSize: 'sm',
          whiteSpace: 'nowrap',
        }}
      >
        {maxLabel ?? `${formatPrice({ price: max })}`}
      </SliderMark>

      <SliderTrack sx={{ h: 2, mt: 3, bg: 'gray.200', borderRadius: 'md' }}>
        <SliderFilledTrack sx={{ bg: 'green.500' }} />
      </SliderTrack>

      <SliderThumb sx={{ w: 6, h: 6, mt: 3 }}>
        <SliderThumbIcon />
      </SliderThumb>
    </Slider>
  )
}